import { render, staticRenderFns } from "./VGuideTemplate.vue?vue&type=template&id=5b59428d&lang=pug"
import script from "./VGuideTemplate.vue?vue&type=script&lang=ts"
export * from "./VGuideTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VGuideTemplate.vue?vue&type=style&index=0&id=5b59428d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports